import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Leadingdemand(props) {
  return (
    <section className="tekrevol_dark_bg  p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Industry">
              <h2>A Trusted Partner In the Digital Healthcare Industry</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Our proficient and experienced team believes in offering practical
              solutions to clients. At TekRevol, healthcare digital solutions
              provide an inclusive suite of services to improve patient care,
              operational optimization, and scale-back costs. We design
              healthcare solutions that are user-oriented and accessible.
            </p>

            <h5>Our Team Acquires:</h5>
            <div className="new-solutionlistwhite">
              <ul>
                <li>In-depth digital health solutions industry knowledge</li>
                <li>Competent technical expertise in information technology</li>
                <li>
                  An aptitude for collecting, analyzing, and interpreting
                  healthcare data
                </li>
                <li>Development and implementation of interoperable systems</li>
                <li>
                  Clinical decision support tools development for digital health
                  technology.
                </li>
              </ul>
            </div>

            <div className="btn_talk">
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Leadingdemand;
